/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Weary_Koala_AffirmInputs */

const fr_last_weary_koala_affirm = /** @type {(inputs: Last_Weary_Koala_AffirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de cours`)
};

/**

* @param {Last_Weary_Koala_AffirmInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const last_weary_koala_affirm = /** @type {((inputs?: Last_Weary_Koala_AffirmInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Weary_Koala_AffirmInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_last_weary_koala_affirm(inputs)
});